import gql from 'graphql-tag';

export const submitUserAssignment = gql`
  mutation submitUserAssignment($classroomId: ID!, $courseAssetId: ID!, $data: AssignmentData!) {
    submitUserAssignment(classroomId: $classroomId, courseAssetId: $courseAssetId, data: $data) {
      ... on UserAssignmentDetailResponse {
        courseRefId
        courseItemRefId
        courseAssetRefId
        userId
        classroomId
        type
        content {
          ... on AssignmentUrlContent {
            url
          }
          ... on AssignmentFileContent {
            fileName
            bucket
            provider
            key
          }
        }
        status
        resultStatus
        score
        studentComment
        reviewedComment
        submittedAt
        reviewedAt
        reviewedBy
        createdAt
        updatedAt
        id
        __typename
      }
    }
  }
`;

export const uploadUserAssignment = gql`
  mutation uploadUserAssignment(
    $classroomId: ID!
    $courseAssetId: ID!
    $data: AssignmentUploadData!
  ) {
    uploadUserAssignment(classroomId: $classroomId, courseAssetId: $courseAssetId, data: $data) {
      ... on UserAssignmentUploadResponse {
        url
        bucket
        key
      }
    }
  }
`;

export const generateSignedUrl = gql`
  mutation generateSignedUrl($id: ID!) {
    generateSignedUrl(id: $id) {
      ... on UserAssignmentSignedUrl {
        url
      }
    }
  }
`;
